module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/summary-infraction-report/summary-infraction-report.component.css
// module id = ./src/app/summary-infraction-report/summary-infraction-report.component.css
// module chunks = main